import { FC } from 'react'
import { OfferSummary } from 'common/types/responses'
import { responses } from 'common/types/mock-data'
import Link from 'next/link'
import { Utils } from 'common/utils'

type OfferCardType = {
  offerInfo: OfferSummary
  titleOption?: 1 | 2
}

const OfferCard: FC<OfferCardType> = ({ offerInfo, titleOption = 1 }) => {
  const tags = responses.tags.filter((tag) => offerInfo.tags.includes(tag.id))

  const backgroundColor = offerInfo.background_gradient
    ? `background-image: ${offerInfo.background_gradient};`
    : `background-color: ${offerInfo.background_color};`
  return (
    <Link
      className='d-block a-unstyled offer-card bg-white p-10'
      href={Utils.getOfferUrl(offerInfo)}
    >
      <p className='color-grey5 text-uppercase text-xs text-semibold'>
        {tags.map((tag) => tag.name)}
      </p>
      <div className='product-container' style={`${backgroundColor}`}>
        <img
          src={offerInfo.image?.url ?? offerInfo.brand.logo.url}
          alt={offerInfo.title}
          className='offer-image'
        />
      </div>
      <div className={`title-container${titleOption} d-flex flex-column`}>
        <h5>{offerInfo.brand.name}</h5>
        <p className='text-medium3 text-semibold color-grey5 pe-8'>
          {offerInfo.title}
        </p>
      </div>
      <div className={`description-container${titleOption}`}>
        <p className='text-small-m text-semibold mb-0'>
          {offerInfo.description}
        </p>
      </div>
    </Link>
  )
}

export default OfferCard
